import { ChangeDetectionStrategy, Component, input, InputSignal, model, output, OutputEmitterRef } from '@angular/core';

import { RessourcesModule } from '@ressources/client/ressources.module';
import { BaseSearchComponent } from '@shared/client/components/search/search.component';

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [RessourcesModule],
    selector: 'app-section-header',
    templateUrl: './section-header.component.html',
})
export class SectionHeaderComponent {
    public readonly itemsName = input.required<string>();
    public search: OutputEmitterRef<string> = output<string>();
    public readonly searchDisabled = input<boolean>(false);
    public readonly searchValue = model<string>('');
    public readonly title: InputSignal<string | undefined> = input<string>();
    public readonly totalItems: InputSignal<number> = input.required<number>();

    protected debounceTimeout: ReturnType<typeof setTimeout> | null = null;

    public clearSearch(): void {
        this.searchValue.set('');
        this.updateSearchValue();
    }

    public updateSearchValue(): void {
        if (this.debounceTimeout) {
            clearTimeout(this.debounceTimeout);
            this.debounceTimeout = null;
        }

        this.debounceTimeout = setTimeout(() => {
            this.search.emit(this.searchValue());
        }, BaseSearchComponent.debounceDuration);
    }
}
